module.exports = __webpack_public_path__ + "ayo-ogunseinde-2.jpg?bfc688ca490f0079051aea5b8ec75cbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/ayo-ogunseinde-2.jpg
// module id = 237
// module chunks = 0